import { createApiClient } from "@/api";

import { type RoleEntity, type RoleEntityRules } from "../types";

const apiClient = createApiClient("json");
const BASE_URL = "/api/main/roles";

const fetchListData = async () => {
  const { data } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const entities: RoleEntity[] = Object.entries(data ?? {}).map(
    ([name, entity]) => ({
      id: name,
      name,
      rules: entity as RoleEntityRules,
    }),
  );

  return {
    data: entities,
    total: entities.length,
  };
};

export const rolesSchema = {
  list: fetchListData,
} as const;
